import { types } from 'mobx-state-tree';
import { useCreateStore, useProvider, useStore } from 'mobx-store-provider';
import React from 'react';

const ExplanationsStore = types
  .model('ExplanationsStore', {
    isViewResult: false,
  })
  .actions((self) => ({
    viewResult() {
      self.isViewResult = true;
    },
    retry() {
      self.isViewResult = false;
    },
  }));

export const useExplanationsStore = () => useStore(ExplanationsStore);

export const withExplanationsStore = (Component) => (props) => {
  const Provider = useProvider(ExplanationsStore);
  const store = useCreateStore(ExplanationsStore, {});

  return (
    <Provider value={store}>
      <Component {...props} />
    </Provider>
  );
};
